import React from 'react'
import styled from 'styled-components'
import intersection from 'lodash/intersection'
import CheckBoxGroup from '@pc/components/Works/Panel/shared/checkbox/CheckBoxGroup'
import CheckBoxInputSet from '@pc/components/Works/Panel/shared/checkbox/CheckBoxInputSet'
import CheckBoxInput from '@pc/components/Works/Panel/shared/checkbox/CheckBoxInput'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/checkbox/CheckBoxLabel'
import ControlGroup from '@pc/components/Works/Panel/shared/ControlGroup'
import type { Line, Station } from '@pc/components/Works/Panel/type'

interface PropsType {
  line: Line
  stations: Station[]
  selectedStationIds: string[]
  changeStationIds: (stationIds: string[]) => void
}

const CheckBoxStationInputSet = styled(CheckBoxInputSet)`
  align-items: center;
  display: flex;
  line-height: 1.4;
  margin-right: 10px;
  width: 110px;
`

const StationControlGroup = styled(ControlGroup)`
  cursor: default;
  margin: 0 15px 15px;
`

const renderStationCheckboxes = (stations: Station[], selectedStationIds: string[], toggleCheckbox: React.ChangeEventHandler) => {
  return stations.map((station) => {
    const stationId = `station-${station.id}`
    return (
      <CheckBoxStationInputSet key={station.id}>
        <CheckBoxInput
          type="checkbox"
          id={stationId}
          value={station.attributes.compat_id}
          onChange={toggleCheckbox}
          checked={selectedStationIds.includes(String(station.attributes.compat_id))}
        />
        <CheckBoxLabel htmlFor={stationId}>{station.attributes.name}</CheckBoxLabel>
      </CheckBoxStationInputSet>
    )
  })
}

const StationCheckboxes = (props: PropsType) => {
  const { line, stations, selectedStationIds, changeStationIds } = props

  const toggleCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target

    if (checked) {
      const concatedStationIds = selectedStationIds.concat(value)
      changeStationIds(concatedStationIds)
      return
    }

    const filteredStationIds = selectedStationIds.filter((selectedStationId) => selectedStationId !== value)
    changeStationIds(filteredStationIds)
  }

  const toggleAllCheckbox = () => {
    const stationIds: string[] = stations.map((station) => station.attributes.compat_id.toString())

    if (isAllSelected()) {
      changeStationIds(selectedStationIds.filter((selectedStationId) => !stationIds.includes(selectedStationId)))
    } else {
      changeStationIds([...new Set([...selectedStationIds, ...stationIds])])
    }
  }

  const isAllSelected = () => {
    const stationIds = stations.map((station) => station.attributes.compat_id.toString())
    return intersection(selectedStationIds, stationIds).length === stationIds.length
  }

  const lineId = `line-${line.id}`

  return (
    <StationControlGroup>
      <CheckBoxGroup>
        <CheckBoxInputSet>
          <CheckBoxInput type="checkbox" id={lineId} onChange={toggleAllCheckbox} checked={isAllSelected()} />
          <CheckBoxLabel htmlFor={lineId}>{line.attributes.name}全て</CheckBoxLabel>
        </CheckBoxInputSet>
      </CheckBoxGroup>
      <CheckBoxGroup>{renderStationCheckboxes(stations, selectedStationIds, toggleCheckbox)}</CheckBoxGroup>
    </StationControlGroup>
  )
}

export default StationCheckboxes
